import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
   GridRow, GridColumn, Grid,
   Table, Tab, Button, Icon, Checkbox,
   Select, ModalHeader,
   ModalDescription,
   ModalContent,
   ModalActions,
   Header,
   Image,
   Modal, Segment,
   FormTextArea,
   FormSelect,
   FormRadio,
   FormInput,
   FormGroup,
   FormCheckbox,
   FormButton,
   Form, Input,
   Loader,
   Dimmer,
   Item,
   Pagination,
   Visibility,
   TableRow,
} from 'semantic-ui-react';
var moment = require('moment');
import { withRouter } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

import { connect } from 'react-redux';
import styled from 'styled-components';
import { WhatsappListAction, WhatsappVendedoresListAction, atualizarQuantidadesParceiroLocal, WhatsappContatoParcListAction, WhatsappInsertContatoParcAction, WhatsappUpdateContatoParcAction, clearParceiros, setVendedorFiltro } from '../../actions/WhatsappActions';

import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { getParceirosLista } from '../../utils/API';
import { use } from 'react';
import TabelaPrecoRevendaModal from './TabelaPrecoRevendaModal';

const options = [
   { key: 'm', text: 'Male', value: 'male' },
   { key: 'f', text: 'Female', value: 'female' },
   { key: 'o', text: 'Other', value: 'other' },
]



const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-bottom: 0px;
    padding: 0px 0px;
  }
`;

const StyledTableHeader = styled(Table.Header)`
  &&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
  }
`;

const StyledTableBody = styled(Table.Body)`
  &&& td {
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
  }
`;


function Relatorio(props) {
   const [loadingPage, setLoadingPage] = useState(false);

   const [vendedorDropdown, setVendedorDropdown] = useState(null);
   //const [vendedoresList, setVendedorDropdown] = useState(null);


   const [linhaSelecionada, setLinhaSelecionada] = useState(null);
   const [linhaEditSelecionada, setLinhaSelecionadaEdit] = useState(null);
   const [linhaTrashSelecionada, setLinhaSelecionadaTrash] = useState(null);
   const [horario, setHorario] = useState(null);


   const [filtro, setFiltro] = useState('');
   const codparcUrl = new URLSearchParams(props.location?.search || '').get('codparc');
   const returnToUrl = new URLSearchParams(props.location?.search || '').get('returnTo');
   const codparcUrlBuscaRef = useRef(false);


   const { userid, vendedoresList, vendedoresLoader, WhatsappVendedoresListAction, parceirosList, parceirosLoader, WhatsappListAction, WhatsappContatoParcListAction, contatosParcLoader, contatosParcList, contatosParcUpdateLoader, contatosParcUpdate, WhatsappUpdateContatoParcAction, WhatsappInsertContatoParcAction, contatosParcInsertLoader, contatosParcInsert, codusu, codvend, tipvend, atualizarQuantidadesParceiroLocal } = props;

   const { filtros } = props;

   const isTableDisabled = parceirosLoader;

   const [openModalFor, setOpenModalFor] = useState(null);
   const [tabelaPrecoParceiro, setTabelaPrecoParceiro] = useState(null);
   const [isReadOnly, setIsReadOnly] = useState(true);
   const [value, setValue] = useState('');
   const [contatos, setContatos] = useState(contatosParcList);
   const [codparcDetalhes, setCodparcDetalhes] = useState();

   const [loadingModal, setLoadingModal] = useState(false);// só na primeira vez começa true


   const [erro, setErro] = useState();
   const [erroEditEmail, setErrorEditEmail] = useState();
   const [erroEditCtt, setErrorEditCtt] = useState();
   const [erroEditFlag, setErrorEditFlag] = useState();
   const [erroEditNome, setErrorEditNome] = useState();
   const [erroEditNunota, setErrorEditNunota] = useState();
   const [erroInsetCtt, setErrorInsetCtt] = useState();

   const [mostrarDeletados, setMostrarDeletados] = useState(false);

   const [dadosContato, setDadosContato] = useState({
      telefone: '',
      email: '',
      nomecontato: '',
      ad_nunota: '',
      ad_isnfe: false,
      ad_iscentregas: false,
      ad_iscomercial: false,
      ad_isprincipal: false,
      codusu: ''
   })

   const StyledModalHeader = styled(Modal.Header)`
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        padding-bottom: 0 !important;
        border-bottom: none !important;
    `;

   const ModalTitle = styled.h2`
        font-weight: 700 !important;
        margin-top: '10px' !important;
        margin-bottom: 1em !important;
    `;

   const StyledModalContent = styled(Modal.Content)`
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        text-align: center !important;
    `;

   const StyledModalActions = styled(Modal.Actions)`
        display: flex !important;
        justify-content: center !important;
        gap: 1rem !important;
        padding-bottom: 2em !important;
        border-top: none !important;
    `;

   useEffect(() => {
      if (parceirosList.length > 0) {
         const totalpages = Math.ceil(parceirosList.length / 15);
         //props.WhatsappSalvaPagination(1, totalpages);
      }
   }, [parceirosList]);

   useEffect(() => {

      if (openModalFor) {
         setLoadingModal(true);

         const timer = setTimeout(() => {
            setLoadingModal(false);
         }, 3200);

         return () => clearTimeout(timer);
      }
   }, [openModalFor]);

   useEffect(() => {
      if (filtros?.vendedorSelect) {
         setVendedorDropdown(filtros.vendedorSelect);
      } else if (vendedoresList?.length > 0 && vendedoresList[0].tipvend !== null) {
         setVendedorDropdown(vendedoresList[0].codvend);
      } else {
         setVendedorDropdown(null);
      }
   }, [vendedoresList]);


   //Lista de parceiros
   useEffect(() => {
      if (codparcUrl && !codparcUrlBuscaRef.current) {
         return;
      }

      if (vendedorDropdown !== null) {
         console.log("Buscando parceiros do vendedor:", vendedorDropdown);

         WhatsappListAction({ codvend: vendedorDropdown, codparc: null });
      }
   }, [vendedorDropdown]);

   useEffect(() => {
      const codparcBusca = String(codparcUrl || '').replace(/\D/g, '');

      if (!codparcBusca || codparcUrlBuscaRef.current) {
         return;
      }

      codparcUrlBuscaRef.current = true;
      setFiltro(codparcBusca);
      WhatsappListAction({ codvend: codvend || vendedorDropdown, codparc: codparcBusca });
   }, [codparcUrl, codvend, vendedorDropdown]);


   const [atualPag, setAtualPag] = useState(1);
   const totalPag = Math.ceil(parceirosList.length / 50);

   const pageSize = 50;
   const startIndex = (atualPag - 1) * pageSize;

   const parceirosPaginados = parceirosList.slice(startIndex, startIndex + pageSize);
   const isParceirosInitialLoading = parceirosLoader && parceirosList.length === 0;
   const isVendedoresInitialLoading = vendedoresLoader && vendedoresList.length === 0;
   const isInitialLoading = isParceirosInitialLoading || isVendedoresInitialLoading;
   const isListaVazia = !isInitialLoading && parceirosPaginados.length === 0;

   //console.log(parceirosPaginados, atualPag, totalPag);


   //lista contatos de parceiros
   const listarContatosParc = (codparc) => {
      WhatsappContatoParcListAction({ codparc: codparc })
   }

   const formRef = useRef(null);

   const handleConfirm = () => {
      if (formRef.current) {
         formRef.current.requestSubmit();
      }
   };


   //regras do nunota
   const [isDisabledInsert, setIsDisabledInsert] = useState(false);
   const [isDisabledEdit, setIsDisabledEdit] = useState(false);

   useEffect(() => {
      if (dadosContato.ad_nunota) {
         setIsDisabledInsert(true);
      } else {
         setIsDisabledInsert(false);
      }
   }, [dadosContato.ad_nunota]);

   useEffect(() => {
      if (dadosContato.ad_nunota) {
         setIsDisabledEdit(true);
      } else {
         setIsDisabledEdit(false);
      }
   }, [dadosContato.ad_nunota]);

   const handleChangeEdit = (e, { name, value, checked, type }) => {
      setContatos((prev) => ({
         ...prev,
         [name]: type === 'checkbox' ? checked : value
      }));
   };

   const handleChange = (e, { name, value, checked, type }) => {
      setDadosContato((prev) => ({
         ...prev,
         [name]: type === 'checkbox' ? checked : value
      }));
   };

   const handleCamposForm = (e, codparc) => {
      e.preventDefault();

      const temDados = dadosContato.telefone?.trim() || dadosContato.email?.trim();
      const flagsSelecionados = dadosContato.ad_isnfe || dadosContato.ad_iscentregas || dadosContato.ad_iscomercial || dadosContato.ad_isprincipal;
      console.log("flagsSelecionados:", flagsSelecionados);

      if (temDados) {
         if (!flagsSelecionados) {
            setErro("Selecione pelo menos um dos campos de tipo de contato!");
            console.log(erro);

         } else {
            handleSalvar(codparc)
            setOpenModalFor(null);
            console.log("deu bom");
            setErro("");
         }

      } else {
         setErro("Preencha pelo menos um dos campos!");
         console.log(erro);
         setErrorInsetCtt(true);
      }
      setErro("");
      console.log("Enviado!");
   };

   const handlePageChange = (event, { activePage }) => {
      setLoadingPage(true);

      setTimeout(() => {
         setAtualPag(activePage);
         setLoadingPage(false);
         window.scrollTo(0, 0);
      }, 0);

   };

   const voltarParaOrigem = () => {
      props.history.push(returnToUrl || '/CupomGerenciador');
   };


   function search() {
      // Quando a busca por código de parceiro for executada, sempre limitar
      // pelo usuário logado (codvend) para aplicar regra: se for supervisor,
      // a procedure retornará parceiros dele e da equipe; se for vendedor,
      // apenas os parceiros dele.
      const usuarioCodvend = codvend || vendedorDropdown;

      if (filtro) {
         WhatsappListAction({ codvend: usuarioCodvend, codparc: filtro });
      } else {
         WhatsappListAction({ codvend: vendedorDropdown, codparc: filtro });
      }

   }

   const handleSalvar = (codparc) => {


      const payload = {
         codparc: codparc,
         ad_whatsappcp: dadosContato.telefone,
         nomecontato: dadosContato.nomecontato,
         email: dadosContato.email,
         nunota: dadosContato.ad_nunota,
         isprincipal: dadosContato.ad_isprincipal ? 'S' : 'N',
         iscomercial: dadosContato.ad_iscomercial ? 'S' : 'N',
         iscentregas: dadosContato.ad_iscentregas ? 'S' : 'N',
         isnfe: dadosContato.ad_isnfe ? 'S' : 'N',
         codusu: codusu
      };

      console.log("parceiro atual: ", codparc);


      WhatsappInsertContatoParcAction(payload)

      setDadosContato({
         telefone: '',
         email: '',
         nomecontato: '',
         ad_nunota: '',
         ad_isprincipal: false,
         ad_iscomercial: false,
         ad_iscentregas: false,
         ad_isnfe: false
      });

      props.atualizarQuantidadesParceiroLocal(
         codparcDetalhes, {
         wpp_entregas_qtd:
            dadosContato.ad_iscentregas === 'S' ? 1 : 0,
         wpp_comercial_qtd:
            dadosContato.ad_iscomercial === 'S' ? 1 : 0,
         email_qtd:
            dadosContato.email ? 1 : 0
      }
      );

   };



   const handleEditar = (codcontato, codparc) => {

      const contatoAlterado = contatos.find(c => c.codcontato === codcontato);

      const contatoOriginal = contatosParcList.find(c => c.codcontato === codcontato);

      if (!contatoAlterado.ad_isnfe && !contatoAlterado.ad_iscentregas && !contatoAlterado.ad_iscomercial) {
         setErrorEditCtt(true);
         return
      }

      console.log("cod contato: ", contatoAlterado.codcontato);


      const payload = {
         codparc: codparcDetalhes,
         ad_whatsappcp: contatoAlterado.ad_whatsappcp,
         email: contatoAlterado.email,
         nunota: contatoAlterado.ad_nunota,
         nomecontato: contatoAlterado.nomecontato,
         isprincipal: contatoAlterado.ad_isprincipal === 'S' ? 'S' : 'N',
         iscomercial: contatoAlterado.ad_iscomercial === 'S' ? 'S' : 'N',
         iscentregas: contatoAlterado.ad_iscentregas === 'S' ? 'S' : 'N',
         isnfe: contatoAlterado.ad_isnfe === 'S' ? 'S' : 'N',
         codusu: codusu,
         dtfim: null,
         codcontato: contatoAlterado.codcontato
      };

      console.log(contatoAlterado.codusu);


      WhatsappUpdateContatoParcAction(payload);

      // WhatsApp Entregas: 
      let diffEntregas = 0;
      if (contatoOriginal.ad_iscentregas !== 'S' && contatoAlterado.ad_iscentregas === 'S') diffEntregas = 1;
      if (contatoOriginal.ad_iscentregas === 'S' && contatoAlterado.ad_iscentregas !== 'S') diffEntregas = -1;

      // WhatsApp Comercial
      let diffComercial = 0;
      if (contatoOriginal.ad_iscomercial !== 'S' && contatoAlterado.ad_iscomercial === 'S') diffComercial = 1;
      if (contatoOriginal.ad_iscomercial === 'S' && contatoAlterado.ad_iscomercial !== 'S') diffComercial = -1;

      // Email (Verifica se antes não tinha e agora tem, ou vice-versa)
      let diffEmail = 0;
      const tinhaEmail = !!contatoOriginal.email;
      const temEmail = !!contatoAlterado.email;
      if (!tinhaEmail && temEmail) diffEmail = 1;
      if (tinhaEmail && !temEmail) diffEmail = -1;

      // Se houve qualquer mudança, despacha para o Redux atualizar a lista principal de parceiros
      if (diffEntregas !== 0 || diffComercial !== 0 || diffEmail !== 0) {
         props.atualizarQuantidadesParceiroLocal(
            codparcDetalhes,
            {
               wpp_entregas_qtd: diffEntregas,
               wpp_comercial_qtd: diffComercial,
               email_qtd: diffEmail
            }
         );
      };
   }

   const mostrarContatosDel = (codparc, codcontato) => {

      const contatosGeral = contatos.map((contato) =>
         contato.codcontato === codcontato);

      const contatosDeletados = contatosGeral.filter(c => c.ad_dtfim != null && c.nomefim);
      // console.log(contatosDeletados);
      // console.log(contatosGeral);
   }

   const temDeletados = contatos.some(item => item.ad_dtfim);

   const temRegraFiscalTabelaPreco = (parceiro) =>
      String(parceiro?.ad_deffiscal || '').toUpperCase() === 'S';

   const temContatosTabelaPreco = (parceiro) =>
      Number(parceiro.wpp_entregas_qtd || 0) > 0 &&
      Number(parceiro.wpp_comercial_qtd || 0) > 0 &&
      Number(parceiro.email_qtd || 0) > 0;

   const podeGerarTabelaPreco = (parceiro) =>
      temRegraFiscalTabelaPreco(parceiro) &&
      temContatosTabelaPreco(parceiro);

   const getTabelaPrecoTooltip = (parceiro) => {
      if (!temRegraFiscalTabelaPreco(parceiro)) {
         return 'Regra fiscal não cadastrada para este cliente. Consulte o depto. de cadastro';
      }

      if (!temContatosTabelaPreco(parceiro)) {
         return 'Disponível apenas para parceiros com WhatsApp Entregas, WhatsApp Comercial e Email cadastrados';
      }

      return 'Gerar tabela de preços da revenda';
   };




   const contatosPrincipais = (codcontato) => {

      return contatos.some(c => c.ad_isprincipal === 'S');

   }

   const reloadModal = (codparc) => {
      WhatsappContatoParcListAction({ codparc: codparc })
   }

   useEffect(() => {
      const listaUnica = Array.from(
         new Map(
            contatosParcList.map(item => [
               item.codcontato + '-' + (item.ad_dtfim || 'ativo'),
               item
            ])
         ).values()
      );

      setContatos(listaUnica);
   }, [contatosParcList]);



   const handleApagar = (codcontato, codparc) => {

      const dateFim = new Date().toISOString();;
      //alterar onde consome
      const novaLista = contatos.map((contato) =>
         contato.codcontato === codcontato
            ? { ...contato, ad_dtfim: dateFim }
            : contato,
      );

      console.log(dateFim);


      setContatos(novaLista)
      const contatoAlterado = novaLista.find(c => c.codcontato === codcontato);



      const payload = {
         codparc: codparcDetalhes,
         ad_whatsappcp: contatoAlterado.ad_whatsappcp,
         email: contatoAlterado.email,
         nunota: contatoAlterado.ad_nunota,
         isprincipal: contatoAlterado.ad_isprincipal = 'N',
         iscomercial: contatoAlterado.ad_iscomercial === 'S' ? 'S' : 'N',
         iscentregas: contatoAlterado.ad_iscentregas === 'S' ? 'S' : 'N',
         isnfe: contatoAlterado.ad_isnfe === 'S' ? 'S' : 'N',
         codusu: codusu,
         dtfim: contatoAlterado.ad_dtfim,
         codcontato: contatoAlterado.codcontato
      };

      console.log('comercial ->', contatoAlterado.ad_iscomercial)

      WhatsappUpdateContatoParcAction(payload)
      props.atualizarQuantidadesParceiroLocal(
         codparcDetalhes,
         {
            wpp_entregas_qtd:
               contatoAlterado.ad_iscentregas === 'S' ? -1 : 0,

            wpp_comercial_qtd:
               contatoAlterado.ad_iscomercial === 'S' ? -1 : 0,

            email_qtd:
               contatoAlterado.email ? -1 : 0
         }
      );

      // WhatsappContatoParcListAction(codparc)

   };

   useEffect(() => {
      setContatos(contatosParcList);
   }, [contatosParcList]);


   return (
      <Tab.Pane >
         <ToastContainer />

         <span style={{ display: 'flex' }}>
            <Dropdown
               style={{ border: '1px solid #1884af', padding: '.5em 1em', borderRadius: '10px' }}
               search
               options={
                  vendedoresList.map((item) => {

                     return {
                        key: item.codvend,
                        text: `${item.apelido}   / (${item.codvend})`,
                        value: item.codvend,
                     };
                  })
               }

               value={vendedorDropdown}

               onChange={(e, { value }) => {
                  props.clearParceiros()
                  setVendedorDropdown(value)
                  props.setVendedorFiltro(value)
               }}
               placeholder='Selecione:'
               loading={parceirosLoader || vendedoresList.length == 0}
            />

            {/* filtro */}


            <label
               style={{ marginLeft: "10em" }} >
               CodParc:
               <Input
                  type='text'
                  inputmode="numeric"
                  pattern="\d*"
                  style={{ height: '40px', marginLeft: '10px', width: '250px', border: '1px solid #1884af', borderRadius: '10px' }}
                  placeholder='Cod Parceiro'
                  icon='search'
                  value={filtro}
                  onChange={(e) => {
                     const onlyNumbers = e.target.value.replace(/\D/g, '');
                     setFiltro(onlyNumbers)
                  }}
                  onKeyDown={(e) => {
                     if (e.key === 'Enter') {
                        e.preventDefault();
                        search();
                     }
                  }}
                  onBlur={() => search()} ></Input>
            </label>

            {codparcUrl ? (
               <Button
                  type='button'
                  icon
                  labelPosition='left'
                  basic
                  color='blue'
                  style={{ height: '40px', marginLeft: '1em' }}
                  onClick={voltarParaOrigem}
               >
                  <Icon name='arrow left' />
                  Voltar para Cupons
               </Button>
            ) : null}
         </span>



         <StyledTable celled id="listParceiros" compact='very' size='small' >
            <StyledTableHeader>
               <Table.Row >
                  <Table.HeaderCell width=".5">Cod Parceiro</Table.HeaderCell>
                  <Table.HeaderCell width="5">Parceiro</Table.HeaderCell>
                  <Table.HeaderCell width="1">Última Compra</Table.HeaderCell>
                  <Table.HeaderCell width="1">Último Orçamento</Table.HeaderCell>
                  <Table.HeaderCell width="1">Último Contato</Table.HeaderCell>
                  <Table.HeaderCell width="2">Quantidade / 1 ano</Table.HeaderCell>
                  <Table.HeaderCell width="2">Quantidade / 4 anos</Table.HeaderCell>
                  <Table.HeaderCell width="2">Quantidade / 8 anos</Table.HeaderCell>
                  {/* <Table.HeaderCell width="1">Quantidade em 4 anos</Table.HeaderCell>
                        <Table.HeaderCell width="1">Valor em 8 anos</Table.HeaderCell>
                        <Table.HeaderCell width="1">Quantidade em 8 anos</Table.HeaderCell> */}
                  <Table.HeaderCell width=".5">WhatsApp Entregas</Table.HeaderCell>
                  <Table.HeaderCell width=".5">WhatsApp Comercial</Table.HeaderCell>
                  <Table.HeaderCell width=".5">Email</Table.HeaderCell>
                  <Table.HeaderCell width="auto">Ações</Table.HeaderCell>
               </Table.Row>
            </StyledTableHeader>

            <Dimmer active={loadingPage} inverted>
               <Loader />
            </Dimmer>
            {isInitialLoading && Array.from({ length: 6 }).map((_, index) => (
               <Table.Row key={`parceiro-loading-${index}`} className='trContent loadingRow'>
                  <Table.Cell><span className='skeletonBlock skeletonSmall' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonWide' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonWide' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonWide' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonWide' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonTiny' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonTiny' /></Table.Cell>
                  <Table.Cell><span className='skeletonBlock skeletonTiny' /></Table.Cell>
                  <Table.Cell>
                     <div className='actionButtons'>
                        <span className='skeletonAction' />
                        <span className='skeletonAction' />
                     </div>
                  </Table.Cell>
               </Table.Row>
            ))}
            {isListaVazia && (
               <Table.Row className='trContent emptySearchRow'>
                  <Table.Cell colSpan={12}>
                     <div className='emptySearchState'>
                        <Icon name='search' />
                        <strong>Nenhum registro encontrado</strong>
                        <span>Nao encontramos parceiros para a busca realizada.</span>
                     </div>
                  </Table.Cell>
               </Table.Row>
            )}
            {!isInitialLoading && parceirosPaginados.map((item, index) =>


               <Table.Row key={`parceiro-${item.codparc}`} className='trContent'>
                  <Table.Cell>{item.codparc}</Table.Cell>
                  <Table.Cell>{item.razaosocial}</Table.Cell>
                  <Table.Cell>
                     {item.dtultcompra == null ? '-' : new Date(item.dtultcompra).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',

                     })}
                  </Table.Cell>
                  <Table.Cell>
                     {item.dtultorcamento == null ? '-' : new Date(item.dtultorcamento).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',

                     })}
                  </Table.Cell>
                  <Table.Cell>{item.dtultcontato == null ? '-' : new Date(item.dtultcontato).toLocaleDateString('pt-BR', {
                     day: '2-digit',
                     month: '2-digit',
                     year: 'numeric',
                  })}
                  </Table.Cell>
                  <Table.Cell>({item.qtdcompras}) - {new Number(item.montantecomprado).toLocaleString('pt-BR',
                     {
                        style: 'currency',
                        currency: 'BRL'
                     })}
                  </Table.Cell>
                  {/* <Table.Cell>{item.qtdcompras}</Table.Cell> */}

                  <Table.Cell>({item.qtdcompras4anos}) - {new Number(item.montantecomprado4anos).toLocaleString('pt-BR',
                     {
                        style: 'currency',
                        currency: 'BRL'
                     })}
                  </Table.Cell>

                  <Table.Cell>({item.qtdcompras8anos}) - {new Number(item.montantecomprado8anos).toLocaleString('pt-BR',
                     {
                        style: 'currency',
                        currency: 'BRL'
                     })}
                  </Table.Cell>

                  {/* <Table.Cell >{item.qtdcompras8anos}</Table.Cell> */}

                  <Table.Cell negative={item.wpp_entregas_qtd == 0 ? true : false}>{item.wpp_entregas_qtd}</Table.Cell>
                  <Table.Cell negative={item.wpp_entregas_qtd == 0 ? true : false}>{item.wpp_comercial_qtd}</Table.Cell>
                  <Table.Cell>{item.email_qtd}</Table.Cell>


                  <Table.Cell>
                     <div className='actionButtons'>
                        <span title={getTabelaPrecoTooltip(item)}>
                           <Button
                              className={`actionBtn actionBtnExcel ${!temRegraFiscalTabelaPreco(item) ? 'actionBtnFiscalBlocked' : ''}`}
                              disabled={!podeGerarTabelaPreco(item)}
                              onClick={() => {
                                 if (podeGerarTabelaPreco(item)) {
                                    setTabelaPrecoParceiro(item);
                                 }
                              }}
                           >
                              <Icon name='file excel outline' />
                           </Button>
                        </span>

                        <Modal

                           open={openModalFor === item.codparc && contatosParcList.length >= 0}
                           onOpen={() => setOpenModalFor(item.codparc)}
                           onClose={() => { setOpenModalFor(null), setIsReadOnly(true), setLinhaSelecionadaEdit(null), setErro(""); }}
                           trigger={
                              <Button
                                 className='actionBtn actionBtnContact'
                                 title='Abrir contatos do parceiro'
                                 //loading={true}
                                 onClick={() => { listarContatosParc(item.codparc), setCodparcDetalhes(item.codparc) }}>
                                 <Icon name='address book outline' />
                              </Button>
                           }
                        >
                           <ModalHeader style={{ padding: 0 }}>
                              <div style={{ backgroundColor: '#dfdfdf', padding: '20px 30px' }}>

                                 <Form id="formInsert" ref={formRef}
                                    onSubmit={(e) => handleCamposForm(e, item.codparc)}>
                                    <Grid>
                                       <GridRow>

                                          <GridColumn width={12}>
                                             <div style={{ display: 'flex', gap: '1rem', width: '100%', marginBottom: '1rem' }}>
                                                {/* nome do contato */}
                                                <GridColumn style={{ width: '50%' }}>
                                                   <Form.Field>
                                                      <label
                                                         style={{ fontWeight: '600', color: '#333' }}>
                                                         Nome do Contato:
                                                      </label>

                                                      <Input
                                                         minLength={3}
                                                         //pattern="\d*"
                                                         type="text"
                                                         placeholder='Nome do Contato:'
                                                         name='nomecontato'

                                                         value={dadosContato.nomecontato}

                                                         onChange={(e) => {

                                                            const onlyLetters = (e.target.value || '').replace(/[^a-zA-ZÀ-ÿ\s]/g, '');
                                                            console.log(onlyLetters);

                                                            handleChange(e, { name: 'nomecontato', value: onlyLetters })
                                                         }
                                                         }
                                                         style={{ borderRadius: '6px', border: '1px solid #ccc' }}
                                                      />
                                                   </Form.Field>
                                                </GridColumn>

                                                <GridColumn style={{ width: '50%' }}>
                                                   <Form.Field>
                                                      <label
                                                         style={{ fontWeight: '600', color: '#333' }}>
                                                         Telefone / Whatsapp
                                                      </label>

                                                      <Input
                                                         minLength={11}
                                                         maxLength={14}
                                                         inputmode="numeric"
                                                         //pattern="\d*"
                                                         type="text"
                                                         placeholder='(00) 00000-0000:'
                                                         name='telefone'

                                                         value={
                                                            `${dadosContato.telefone.substring(0, 2)} ${dadosContato.telefone.substring(2, 11)}`}

                                                         onChange={(e) => {
                                                            const onlyNumbers = (e.target.value || '').replace(/\D/g, '');
                                                            console.log(onlyNumbers);

                                                            handleChange(e, { name: 'telefone', value: onlyNumbers })
                                                         }
                                                         }
                                                         style={{ borderRadius: '6px', border: '1px solid #ccc' }}
                                                      />
                                                   </Form.Field>
                                                </GridColumn>

                                             </div>


                                             <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>

                                                <GridColumn style={{ width: '50%' }}>
                                                   <Form.Field>
                                                      <label style={{ fontWeight: '600', color: '#333' }}>
                                                         Email:

                                                      </label>
                                                      <Input
                                                         placeholder='email@email.com'
                                                         style={{ borderRadius: '6px', border: '1px solid #ccc' }}
                                                         name='email'
                                                         type='email'
                                                         value={dadosContato.email}
                                                         //onChange={(e) => handleChange(e, { name: 'email', value: e.target.value })}
                                                         onChange={(e) => {

                                                            const email = e.target.value
                                                            console.log(email);


                                                            if (email.includes("@esplane.com.br")) {
                                                               setErrorEditEmail(true);
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Email não cadastrado!</b></p>
                                                                     <p style={{ margin: 0 }}>Email inválido!</p>

                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               return;
                                                            }

                                                            setErrorEditEmail(false);
                                                            handleChange(e, { name: 'email', value: email })

                                                         }}
                                                      //handleChange(e, { name: 'email', value: e.target.value }) }

                                                      />
                                                   </Form.Field>
                                                </GridColumn>

                                                {/* nunotaRulles */}
                                                <GridColumn style={{ width: '50%' }}>
                                                   <Form.Field>
                                                      <label style={{ fontWeight: '600', color: '#333' }}>Nunota:</label>

                                                      <Input
                                                         placeholder='00000'
                                                         style={{ borderRadius: '6px', border: '1px solid #ccc' }}
                                                         name='ad_nunota'
                                                         type='text'
                                                         value={dadosContato.ad_nunota}
                                                         //onChange={(e) => handleChange(e, { name: 'email', value: e.target.value })}
                                                         onChange={handleChange} />
                                                   </Form.Field>
                                                </GridColumn>

                                             </div>
                                          </GridColumn>

                                          <GridColumn width={4}>
                                             <div style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'center' }}>

                                                <GridColumn width={3} style={{ display: 'flex', alignItems: 'center', marginRight: '1rem', justifyContent: 'center' }}>
                                                   <FormGroup className='inputCheckbox' inline style={{ margin: 0, display: 'block' }}>
                                                      <FormCheckbox label='Nfe' style={{ width: '100%' }} name='ad_isnfe' checked={dadosContato.ad_isnfe} onChange={handleChange} />

                                                      <FormCheckbox label='Entrega' style={{ width: '100%' }} name='ad_iscentregas' checked={dadosContato.ad_iscentregas} onChange={handleChange} />

                                                      <FormCheckbox label='Comercial' style={{ width: '100%' }} name='ad_iscomercial' checked={dadosContato.ad_iscomercial} onChange={handleChange} />

                                                      <FormCheckbox label='Principal' style={{ width: '100%' }} name='ad_isprincipal' checked={dadosContato.ad_isprincipal} onChange={handleChange} disabled={!!dadosContato.ad_nunota || contatosPrincipais()} />
                                                   </FormGroup>
                                                </GridColumn>

                                             </div>
                                          </GridColumn>
                                       </GridRow>
                                    </Grid>
                                 </Form>

                                 <ModalActions>
                                    <Button
                                       type='submit'
                                       form='formInsert'
                                       loading={contatosParcInsertLoader}
                                       content="SALVAR"
                                       labelPosition='right'
                                       icon='checkmark'
                                       onClick={() => {
                                          setErrorInsetCtt(true)
                                          if (!dadosContato.telefone?.trim() && !dadosContato.email?.trim()) {
                                             setErrorEditEmail(true);

                                             toast.error(
                                                <div>
                                                   <p style={{ margin: 0 }}><b>Email e WhatsApp não cadastrados!</b></p>
                                                   <p style={{ margin: 0 }}>Email e WhatsApp inválidos!</p>
                                                   <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                </div>,
                                                {
                                                   position: "top-right",
                                                   autoClose: 4000,
                                                   hideProgressBar: false,
                                                   closeOnClick: true,
                                                   draggable: true,
                                                   progress: undefined,
                                                   style: {
                                                      background: "#fff",
                                                      color: "#000",
                                                   },
                                                }
                                             );
                                             return
                                          }
                                          if (!dadosContato.ad_isnfe && !dadosContato.ad_iscentregas && !dadosContato.ad_iscomercial) {
                                             toast.error(
                                                <div>
                                                   <p style={{ margin: 0 }}><b>Selecione pelo menos uma opção!</b></p>
                                                   <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                </div>,
                                                {
                                                   position: "top-right",
                                                   autoClose: 4000,
                                                   hideProgressBar: false,
                                                   closeOnClick: true,
                                                   draggable: true,
                                                   progress: undefined,
                                                   style: {
                                                      background: "#fff",
                                                      color: "#000",
                                                   },
                                                }
                                             );
                                             return
                                          }
                                       }}
                                       positive
                                    />
                                 </ModalActions></div>
                           </ModalHeader>

                           <ModalContent image scrolling>



                              <ModalDescription >
                                 <Segment style={{ display: 'flex', alignItems: 'center', border: 'none' }}>
                                    <Button className='btnDel' onClick={() => setMostrarDeletados(prev => !prev)} >
                                       {mostrarDeletados ? "Ocultar deletados" : "Mostrar deletados"}
                                    </Button>
                                    <div style={{ marginLeft: '2em' }}>
                                       <p style={{ color: '#777' }}><b>Codparc: </b>{item.codparc}</p>
                                       <p style={{ color: '#777' }}><b>Nome Parceiro: </b>{item.razaosocial}</p>
                                    </div>
                                 </Segment>
                                 <Segment className='loaderContatosParc'>
                                    <StyledTable celled id="listInfoParceiros" compact='very' size='small' >

                                       <StyledTableHeader>
                                          <Table.Row width="100%">
                                             <Table.HeaderCell width="1">Criação</Table.HeaderCell>
                                             <Table.HeaderCell width="1">Alteração</Table.HeaderCell>
                                             <Table.HeaderCell width="2">Nome</Table.HeaderCell>

                                             <Table.HeaderCell width="1" style={{ display: mostrarDeletados && temDeletados ? '' : 'none', textAlign: 'center' }}>Data exclusão</Table.HeaderCell>


                                             <Table.HeaderCell width="2">
                                                <Icon name='whatsapp' style={{ fontSize: '2.5em', color: '#1DAA61' }} />
                                             </Table.HeaderCell>
                                             <Table.HeaderCell width="3">Email</Table.HeaderCell>
                                             <Table.HeaderCell width="1">NuNota</Table.HeaderCell>
                                             <Table.HeaderCell width="2">Principal</Table.HeaderCell>
                                             <Table.HeaderCell width="1">Nfe</Table.HeaderCell>
                                             <Table.HeaderCell width="1">Entrega</Table.HeaderCell>
                                             <Table.HeaderCell width="1">Comercial</Table.HeaderCell>
                                             <Table.HeaderCell width="1"></Table.HeaderCell>
                                             <Table.HeaderCell width="1"></Table.HeaderCell>

                                          </Table.Row>
                                       </StyledTableHeader>


                                       <Dimmer active={loadingModal} inverted style={{ display: 'block' }}>
                                          <Loader inline='centered' />
                                       </Dimmer>



                                       {contatos.filter(item => mostrarDeletados || (item.ad_dtfim == null && item.codusu_fim == null)).map((item) =>

                                          <Table.Row
                                             key={`${codparcDetalhes}-${item.codcontato}-${item.ad_dtfim || 'ativo'}`}
                                             disabled={item.ad_dtfim != null}
                                             style={{ backgroundColor: item.ad_dtfim ? '#dbdbdb' : 'white' }}

                                             className={item.ad_dtfim ? 'dtfimTrue' : 'dtfimFalse'}
                                          >


                                             <Table.Cell><span>{item.ad_nomeusu_inicio} </span></Table.Cell>

                                             <Table.Cell><span>{item.ad_nomeusu_fim} </span></Table.Cell>

                                             <Table.Cell className="cellModalCtt" width={"100px"} >

                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input
                                                      //pattern="\d*"
                                                      type="text"
                                                      name='nomecontato'

                                                      value={item.nomecontato}

                                                      onChange={(e) => {

                                                         const onlyLetters = (e.target.value || '').replace(/[^a-zA-ZÀ-ÿ\s]/g, '');
                                                         console.log(onlyLetters);

                                                         //if (onlyLetters.length <= 2) return;

                                                         const novaLista = contatos.map((contato) =>
                                                            contato.codcontato === item.codcontato
                                                               ? { ...contato, nomecontato: onlyLetters }
                                                               : contato
                                                         );


                                                         setContatos(novaLista);
                                                      }
                                                      } readOnly={isReadOnly}
                                                      style={{
                                                         border: isReadOnly ? 'none' : erroEditNome ? '1px solid #ff0000' : '1px solid #777',
                                                         outline: isReadOnly ? 'none' : erroEditNome ? 'none' : '1px solid #777',
                                                         backgroundColor: isReadOnly ? 'transparent' : '#ccc',
                                                         transition: isReadOnly ? 'none' : '.3s',
                                                         textAlign: 'center',
                                                         padding: '.5em .5em',
                                                         borderRadius: '10px',
                                                         width: '70px; !important'
                                                      }}
                                                      placeholder={item.nomecontato} />
                                                ) : (
                                                   <span>{item.nomecontato}</span>
                                                )}

                                             </Table.Cell>

                                             <Table.Cell style={{ display: mostrarDeletados && temDeletados ? '' : 'none' }}>

                                                {item.ad_dtfim && (
                                                   <span>{
                                                      new Date(item.ad_dtfim).toLocaleDateString('pt-BR', {
                                                         day: '2-digit',
                                                         month: '2-digit',
                                                         year: 'numeric',

                                                      })}
                                                   </span>
                                                )}

                                             </Table.Cell>

                                             <Table.Cell className="cellModalCtt" width={"100px"} >

                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input
                                                      inputmode="numeric"
                                                      className='inputcellModalCtt'
                                                      pattern="\d*"
                                                      minLength={11}
                                                      maxLength={14}
                                                      type='text'
                                                      value={item.ad_whatsappcp
                                                         ? `(${item.ad_whatsappcp.substring(0, 2)}) ${item.ad_whatsappcp.substring(2, 11)}`
                                                         : ''}
                                                      // const onlyNumbers = e.target.value.replace(/\D/g, '');
                                                      // handleChange(e, { name: 'telefone', value: onlyNumbers })

                                                      onChange={(e) => {
                                                         const onlyNumbers = e.target.value.replace(/\D/g, '');


                                                         if (onlyNumbers.length <= 14 && onlyNumbers.length >= 13) return;

                                                         const novaLista = contatos.map((contato) =>
                                                            contato.codcontato === item.codcontato
                                                               ? { ...contato, ad_whatsappcp: onlyNumbers }
                                                               : contato
                                                         );


                                                         setContatos(novaLista);
                                                      }
                                                      } readOnly={isReadOnly}
                                                      style={{
                                                         border: isReadOnly ? 'none' : erroEditCtt ? '1px solid #ff0000' : '1px solid #777',
                                                         outline: isReadOnly ? 'none' : erroEditCtt ? 'none' : '1px solid #777',
                                                         backgroundColor: isReadOnly ? 'transparent' : '#ccc',
                                                         transition: isReadOnly ? 'none' : '.3s',
                                                         textAlign: 'center',
                                                         padding: '.5em .5em',
                                                         borderRadius: '10px',
                                                         width: '70px; !important'
                                                      }}
                                                      placeholder={item.ad_whatsappcp} />
                                                ) : (
                                                   <span>{item.ad_whatsappcp ? `(${item.ad_whatsappcp.substring(0, 2)}) ${item.ad_whatsappcp.substring(2, 11)}` : '-'}</span>
                                                )}

                                             </Table.Cell>

                                             <Table.Cell>
                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input
                                                      type='email'
                                                      value={item.email}
                                                      onChange={(e) => {
                                                         const novaLista = contatos.map((contato) =>
                                                            contato.codcontato === item.codcontato
                                                               ? { ...contato, email: e.target.value }
                                                               : contato
                                                         );

                                                         setContatos(novaLista);
                                                      }} readOnly={isReadOnly}
                                                      style={{
                                                         textAlign: 'center',
                                                         border: isReadOnly ? 'none' : erroEditEmail ? '1px solid #ff0000' : '1px solid #777',
                                                         outline: isReadOnly ? 'none' : erroEditEmail ? 'none' : '1px solid #777',
                                                         backgroundColor: isReadOnly ? 'transparent' : '#ccc',
                                                         transition: isReadOnly ? 'none' : '.3s',
                                                         padding: '.5em .5em',
                                                         borderRadius: '10px',
                                                         width: '70px; !important'
                                                      }}
                                                      placeholder={item.email} />
                                                ) : (
                                                   <span>{item.email}</span>
                                                )}
                                             </Table.Cell>

                                             <Table.Cell className="cellModalCtt" width={"120px"}>
                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input
                                                      type='text'
                                                      value={item.ad_nunota}
                                                      onChange={(e) => {
                                                         //handleChangeEdit(e, { name: 'ad_nunota', value: e.target.value })
                                                         const novoNuNota = e.target.value;
                                                         const desmarcarPrincipal = item.ad_isprincipal === 'S' && novoNuNota && novoNuNota.trim() !== '';

                                                         const novaLista = contatos.map((contato) =>
                                                            contato.codcontato === item.codcontato
                                                               ? {
                                                                  ...contato,
                                                                  ad_nunota: e.target.value,
                                                                  ad_isprincipal: desmarcarPrincipal ? 'N' : contato.ad_isprincipal
                                                               }
                                                               : contato
                                                         );
                                                         setContatos(novaLista);

                                                      }} readOnly={isReadOnly}

                                                      style={{
                                                         border: isReadOnly ? 'none' : erroEditNunota ? '1px solid #ff0000' : '1px solid #777',
                                                         outline: isReadOnly ? 'none' : erroEditNunota ? 'none' : '1px solid #777',
                                                         textAlign: 'center',
                                                         backgroundColor: isReadOnly ? 'transparent' : '#ccc',
                                                         transition: isReadOnly ? 'none' : '.3s',
                                                         padding: '.5em .5em',
                                                         borderRadius: '10px',
                                                         width: '70px; !important'
                                                      }}
                                                      placeholder={item.ad_nunota} />
                                                ) : (
                                                   <span>{item.ad_nunota}</span>
                                                )}
                                             </Table.Cell>

                                             <Table.Cell>

                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (

                                                   <Segment style={{ background: 'blue !important', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                                      <Checkbox toggle
                                                         cursor='pointer'
                                                         disabled={!!item.ad_nunota}
                                                         className='toggleBtnEdit'
                                                         onChange={(e, data) => {
                                                            //contatoAtual = contatos.find(c => c.codcontato === item.codcontato);
                                                            const novoValor = data.checked ? 'S' : 'N';

                                                            const novaLista = contatos.map((contato) => {
                                                               if (novoValor === 'S') {
                                                                  return {
                                                                     ...contato,
                                                                     ad_isprincipal: contato.codcontato === item.codcontato ? 'S' : 'N'
                                                                  };
                                                               }

                                                               if (contato.codcontato === item.codcontato) {
                                                                  return { ...contato, ad_isprincipal: 'N' }
                                                               }

                                                               return contato;
                                                            });
                                                            setContatos(novaLista);
                                                         }}
                                                         checked={item.ad_isprincipal == 'S'}
                                                      />
                                                   </Segment>
                                                ) : (
                                                   <Segment className='togleDisabled'>
                                                      <Checkbox
                                                         fitted={true}
                                                         disabled={true}
                                                         className={`toggleBtn ${linhaEditSelecionada ? 'toggle-ativo' : 'togleDisabled'}`}
                                                         toggle
                                                         cursor='not-allowed'
                                                         checked={item.ad_isprincipal == 'S' ? true : false}
                                                      />

                                                   </Segment>
                                                )}

                                             </Table.Cell>

                                             <Table.Cell>
                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input type='checkbox' onChange={(e) => {
                                                      //pesquisar como editar checkbox
                                                      const novoValor = e.target.checked ? 'S' : 'N';

                                                      const novaLista = contatos.map((contato) =>
                                                         contato.codcontato === item.codcontato
                                                            ? { ...contato, ad_isnfe: novoValor }
                                                            : contato
                                                      );

                                                      setContatos(novaLista);
                                                   }} checked={item.ad_isnfe == 'S'}></input>

                                                ) : (<input type='checkbox' checked={item.ad_isnfe == 'S'} readOnly ></input>)}
                                             </Table.Cell>

                                             <Table.Cell>
                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input type='checkbox' onChange={(e) => {
                                                      //pesquisar como editar checkbox
                                                      const novoValor = e.target.checked ? 'S' : 'N';

                                                      const novaLista = contatos.map((contato) =>
                                                         contato.codcontato === item.codcontato
                                                            ? { ...contato, ad_iscentregas: novoValor }
                                                            : contato
                                                      );

                                                      setContatos(novaLista);
                                                   }} checked={item.ad_iscentregas == 'S'}></input>

                                                ) : (<input type='checkbox' checked={item.ad_iscentregas == 'S'} readOnly ></input>)}

                                             </Table.Cell>

                                             <Table.Cell>
                                                {linhaEditSelecionada !== null && linhaEditSelecionada == item.codcontato ? (
                                                   <input type='checkbox' onChange={(e) => {
                                                      //pesquisar como editar checkbox
                                                      const novoValor = e.target.checked ? 'S' : 'N';

                                                      const novaLista = contatos.map((contato) =>
                                                         contato.codcontato === item.codcontato
                                                            ? { ...contato, ad_iscomercial: novoValor }
                                                            : contato
                                                      );

                                                      setContatos(novaLista);
                                                   }} checked={item.ad_iscomercial == 'S'}></input>

                                                ) : (<input type='checkbox' checked={item.ad_iscomercial == 'S'} readOnly ></input>)}
                                             </Table.Cell>

                                             <Table.Cell>
                                                {linhaEditSelecionada === item.codcontato ? (
                                                   <>
                                                      <Button
                                                         style={{ fontSize: '8px' }}
                                                         basic
                                                         icon='check'
                                                         color='green'
                                                         onClick={() => {
                                                            const contatoAtual = contatos.find(c => c.codcontato === item.codcontato);
                                                            const telefone = contatoAtual?.ad_whatsappcp || '';
                                                            const email = contatoAtual?.email || '';
                                                            console.log(telefone.length);

                                                            if ((telefone.length < 10 || telefone.length > 11) && (!email.includes("@") || !email.includes(".") || email.startsWith("@") || email.endsWith("@"))) {
                                                               setErrorEditCtt(true);
                                                               setErrorEditEmail(true);
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Email não atualizado!</b></p>
                                                                     <p style={{ margin: 0 }}>Email inválido!</p>
                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Número de WhatsApp foi atualizado!</b></p>
                                                                     <p style={{ margin: 0 }}>Número de WhatsApp inválido</p>
                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               return
                                                            }

                                                            if (telefone.length < 10 || telefone.length > 11) {
                                                               setErrorEditCtt(true);
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Número de WhatsApp foi atualizado!</b></p>
                                                                     <p style={{ margin: 0 }}>Número de WhatsApp inválido</p>

                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               setErrorEditEmail(false);
                                                               return;
                                                            }

                                                            if (!email.includes("@") || !email.includes(".") || email.startsWith("@") || email.endsWith("@") || email.includes("@esplane.com.br")) {
                                                               setErrorEditCtt(false);
                                                               setErrorEditEmail(true);
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Email não foi atualizado!</b></p>
                                                                     <p style={{ margin: 0 }}>Email inválido!</p>

                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               return;
                                                            }

                                                            if ((contatoAtual.nomecontato || '').trim().length < 3) {
                                                               setErrorEditNome(true);
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Nome do contato não foi atualizado!</b></p>
                                                                     <p style={{ margin: 0 }}>O nome deve conter pelo menos 3 caracteres!</p>
                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               return;
                                                            }


                                                            if (contatoAtual.ad_isprincipal !== 'S' &&
                                                               contatoAtual.ad_isnfe !== 'S' &&
                                                               contatoAtual.ad_iscentregas !== 'S' &&
                                                               contatoAtual.ad_iscomercial !== 'S') {
                                                               toast.error(
                                                                  <div>
                                                                     <p style={{ margin: 0 }}><b>Selecione pelo menos uma opção!</b></p>
                                                                     <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                                                                  </div>,
                                                                  {
                                                                     position: "top-right",
                                                                     autoClose: 4000,
                                                                     hideProgressBar: false,
                                                                     closeOnClick: true,
                                                                     draggable: true,
                                                                     progress: undefined,
                                                                     style: {
                                                                        background: "#fff",
                                                                        color: "#000",
                                                                     },
                                                                  }
                                                               );
                                                               return
                                                            }

                                                            setErrorEditFlag(false);
                                                            setErrorEditCtt(false);
                                                            setErrorEditEmail(false);

                                                            handleEditar(item.codcontato, item.codparc),
                                                               setLinhaSelecionadaEdit(null)
                                                         }}
                                                      />
                                                      <Button
                                                         style={{ fontSize: '8px' }}
                                                         basic
                                                         icon='cancel'
                                                         color='red'
                                                         onClick={() => {
                                                            setLinhaSelecionadaEdit(null),
                                                               setIsReadOnly(true, item.codcontato)
                                                         }}
                                                      />
                                                   </>
                                                ) : (
                                                   <button style={{ background: 'none', outline: 'none', border: 'none', textAlign: 'center', margin: '0 auto', padding: '0', width: '100%', cursor: 'pointer' }} >
                                                      <Icon
                                                         size='large'
                                                         style={{ fontSize: '1.5em' }}
                                                         disabled={item.is_exclusao === 1 ? true : false}
                                                         name='edit'
                                                         onClick={() => {
                                                            setLinhaSelecionadaEdit(item.codcontato)
                                                            { isReadOnly ? setIsReadOnly(isReadOnly == false) : setIsReadOnly(isReadOnly == true) }
                                                         }}
                                                         color={item.is_exclusao === 0 ? 'red' : 'grey'} />

                                                   </button>
                                                )}
                                             </Table.Cell>

                                             <Table.Cell>
                                                {linhaTrashSelecionada === item.codcontato ? (

                                                   <>
                                                      <Button
                                                         style={{ fontSize: '8px' }}
                                                         basic
                                                         icon='check'
                                                         color='green'
                                                         onClick={() => {

                                                            handleApagar(item.codcontato, item.codparc);
                                                            setLinhaSelecionadaTrash(null);
                                                            //reloadModal(item.codparc)
                                                         }}
                                                      />
                                                      <Button
                                                         style={{ fontSize: '8px' }}
                                                         basic
                                                         icon='cancel'
                                                         color='red'
                                                         onClick={() => setLinhaSelecionadaTrash(null)}
                                                      />
                                                   </>
                                                ) : (
                                                   <button style={{ background: 'none', outline: 'none', border: 'none', textAlign: 'center', margin: '0 auto', padding: '0', width: '100%', cursor: 'pointer' }} >
                                                      <Icon
                                                         size='large'
                                                         style={{ fontSize: '1.5em' }}
                                                         disabled={item.is_exclusao === 1 ? true : false}
                                                         name='trash alternate'
                                                         onClick={() => {
                                                            setLinhaSelecionadaTrash(item.codcontato);

                                                         }} color={item.is_exclusao === 0 ? 'red' : 'grey'} />

                                                   </button>
                                                )}
                                             </Table.Cell>
                                          </Table.Row>


                                       )}

                                       <StyledTableBody>
                                       </StyledTableBody>

                                    </StyledTable>
                                 </Segment>

                              </ModalDescription>
                           </ModalContent>
                           <ModalActions>
                              <Button

                                 content="FECHAR"
                                 labelPosition='right'
                                 icon='close'
                                 onClick={() => {
                                    setOpenModalFor(null)
                                    setLinhaSelecionadaEdit(null)
                                    console.log(mostrarContatosDel(item.codparc, item.codcontato))
                                 }}
                                 negative
                              />
                           </ModalActions>
                        </Modal>
                     </div>

                  </Table.Cell>
               </Table.Row>
            )}

            <StyledTableBody>
            </StyledTableBody>
         </StyledTable>

         <div style={{ textAlign: 'right', marginTop: '10px' }}>
            <Pagination
               style={{ display: parceirosList.length > 50 ? '' : 'none' }}
               pointing
               secondary
               boundaryRange={0}
               defaultActivePage={1}
               ellipsisItem={null}
               firstItem={1}
               siblingRange={1}
               activePage={atualPag}
               totalPages={totalPag}
               onPageChange={handlePageChange}
            />
         </div>

         <TabelaPrecoRevendaModal
            open={!!tabelaPrecoParceiro}
            parceiro={tabelaPrecoParceiro}
            codvend={vendedorDropdown}
            vendedor={vendedoresList.find((item) => item.codvend === vendedorDropdown)}
            onClose={() => setTabelaPrecoParceiro(null)}
         />


         <style>{`


                .ui.active.modal{
                    width: 90% !important;
                }

                .ui.segment{
                    brackground-color: transparent !important;
                    drop-shadow: none !important;
                    box-shadow: none !important;
                }

                .ui.modal .actions>.button{
                    margin: 1.5em 0 0 .6em !important;
                }

                .ui.button.btnDel{
                    background-color: #1884AF !important;
                    color: white !important;
                }
                .ui.button.btnDel:hover{
                    background-color: #1884AF !important;
                    color: white !important;
                }

                .ui.celled.table tr th{
                    padding: 1em .5em !important;
                }
                table > .trContent{
                   line-height: auto !important;
                }

                .ui.celled.table tr td{
                    font-size: .9em !important;
                    text-align: center;
                    padding: 0 .5em ;
                }

                .edit.icon:hover{
                    color: #666 !important;
                    transition: .3s !important
                }
                .trash.icon:hover{
                    color: #666 !important;
                    transition: .3s !important
                }
                .infoBtn{
                    padding: 0.4em 0.7em !important
                }

                .actionButtons{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    min-width: 72px;
                }

                .actionButtons > span{
                    display: inline-flex;
                }

                .ui.button.actionBtn{
                    width: 30px;
                    height: 30px;
                    min-height: 30px;
                    padding: 0 !important;
                    margin: 0 !important;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    border: 1px solid transparent;
                    box-shadow: none;
                    transition: .2s ease;
                }

                .ui.button.actionBtn > i.icon{
                    margin: 0 !important;
                    font-size: 1.15em;
                }

                .ui.button.actionBtnExcel{
                    background: #ecfbf1 !important;
                    border-color: #b9e5c6 !important;
                    color: #1f8f4d !important;
                }

                .ui.button.actionBtnFiscalBlocked,
                .ui.button.actionBtnFiscalBlocked.disabled,
                .ui.button.actionBtnFiscalBlocked:disabled{
                    background: #fff0f0 !important;
                    border-color: #f0b4b4 !important;
                    color: #c62828 !important;
                    opacity: 1 !important;
                }

                .ui.button.actionBtnContact{
                    background: #eef8fc !important;
                    border-color: #b9dceb !important;
                    color: #1884af !important;
                }

                .ui.button.actionBtn:hover{
                    filter: brightness(.97);
                    transform: translateY(-1px);
                }

                .ui.button.actionBtn.disabled,
                .ui.button.actionBtn:disabled{
                    background: #f3f3f3 !important;
                    border-color: #e1e1e1 !important;
                    color: #a7a7a7 !important;
                    opacity: 1 !important;
                    transform: none;
                }

                .ui.button.actionBtnFiscalBlocked.disabled,
                .ui.button.actionBtnFiscalBlocked:disabled{
                    background: #fff0f0 !important;
                    border-color: #f0b4b4 !important;
                    color: #c62828 !important;
                }

                .loadingRow td{
                    height: 34px;
                    background: #fbfcfd;
                }

                .emptySearchRow td{
                    background: #fbfcfd;
                    padding: 2.25em 1em !important;
                }

                .emptySearchState{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: .35em;
                    color: #5f6f7a;
                    min-height: 105px;
                }

                .emptySearchState > i.icon{
                    width: 42px;
                    height: 42px;
                    line-height: 42px;
                    margin: 0 0 .35em 0 !important;
                    border-radius: 50%;
                    background: #eef8fc;
                    color: #1884af;
                    font-size: 1.25em;
                }

                .emptySearchState > strong{
                    color: #24343d;
                    font-size: 1.05em;
                }

                .emptySearchState > span{
                    font-size: .95em;
                }

                .skeletonBlock,
                .skeletonAction{
                    display: inline-block;
                    height: 12px;
                    border-radius: 8px;
                    background: linear-gradient(90deg, #edf1f4 0%, #f7f9fb 45%, #edf1f4 90%);
                    background-size: 220% 100%;
                    animation: contatosParcSkeleton 1.15s ease-in-out infinite;
                }

                .skeletonBlock{
                    width: 74%;
                    max-width: 170px;
                }

                .skeletonSmall{
                    width: 46px;
                }

                .skeletonWide{
                    width: 86%;
                    max-width: 250px;
                }

                .skeletonTiny{
                    width: 22px;
                }

                .skeletonAction{
                    width: 30px;
                    height: 30px;
                    border-radius: 6px;
                }

                @keyframes contatosParcSkeleton{
                    0% { background-position: 120% 0; }
                    100% { background-position: -120% 0; }
                }

                .infoBtn:hover>i.icon.info.circle{
                    color: #1884afc2 !important;
                    transition: .3s !important;
                }
                
                .ui.search.selection.upward.dropdown{
                    background-color: #1884af !important;
                    color: white !important;
                }
                .ui.selection.dropdown .menu>.item:hover{
                    background-color: #1884af3a !important;
                    transition: .3s !important;
                }

                .ui.table thead tr th{
                    padding: 0 .5em !important;
                    text-align: center !important;
                }


                //------------------------

                div.ui.compact.segment{
                width: 100%;
                    display: block !important;
                    border: none !important;
                    margin: 0 auto !important;
                }
                td div.ui.segment {
                    border: none !important;
                    padding: 0;
                    margin: 0 auto !important;
                    background-color: transparent !important;
                }

               //--------------------------------
               .ui.segment.togleDisabled{
                  cursor: not-allowed !important;
               }

               .ui.disabled.checkbox label,
               .ui.checkbox input[disabled]~label {
                  cursor: not-allowed !important;
               }

               ${linhaEditSelecionada != null ? `.ui.toggle.checkbox label:hover:before{background: #0D71BB !important;}` : `.ui.toggle.checkbox label:hover:before{background: #0D71BB !important;}`}
                
               .ui.toggle.checkbox label:before{
                  background: #979797;
                }
               .ui.toggle.checkbox label:hover::before {
                  background: ${linhaEditSelecionada != null ? '#979797' : '#979797'} !important;
               }
               .ui.toggleBtnEdit.toggle.checkbox label:hover::before {
                  background: ${linhaEditSelecionada != null ? '#616161' : '#979797'} !important;
               }
               

                

                //------------------------

                button.ui.button.btnConfirm:hover{
                    background-color: #236623 !important;
                    color: black !important;
                    transition: .3s !important;
                }
                .btnCancel:hover{
                    background-color: #8a0d0d !important;
                    transition: .3s !important;
                }


                .cellModalCtt input[type=email], 
                .cellModalCtt input[type=password], 
                .cellModalCtt input[type=search], 
                .cellModalCtt input[type=text] {
                    width: 100% !important;
                }


                .ui.grid>.row>[class*="three wide"].column .ui.form .inline.fields .field {
                    paddign: 0 !important;
                    width:'100%' !important;
                }

                .dtfimTrue.ui.compact.segment, 
                .dtfimFalse.ui.compact.segment{
                    background: transparent !important;
                    border:none !important;
                    box-shadow: 0px 0px 0px white !important;
                }

                //------------------------

                .ui.active.centered.inline.loader{
                    height: 3em
                }

                //------------------------
          
            
            `}</style>

      </Tab.Pane >
   )
};


const mapStateToProps = (state) => ({
   vendedoresList: state.WhatsappReducer.vendedoresList,
   userid: state.LoginReducer.userid,
   codusu: state.LoginReducer.codusu,
   tipvend: state.LoginReducer.tipvend,
   codvend: state.LoginReducer.vendedorvcc,
   vendedoresLoader: state.WhatsappReducer.vendedoresLoader,

   parceirosList: state.WhatsappReducer.parceirosList,
   parceirosLoader: state.WhatsappReducer.parceirosLoader,

   contatosParcList: state.WhatsappReducer.contatosParcList,
   contatosParcLoader: state.WhatsappReducer.contatosParcLoader,

   contatosParcUpdate: state.WhatsappReducer.contatosParcUpdate,
   contatosParcUpdateLoader: state.WhatsappReducer.contatosParcUpdateLoader,

   contatosParcInsert: state.WhatsappReducer.contatosParcInsert,
   contatosParcInsertLoader: state.WhatsappReducer.contatosParcInsertLoader,

   clearParceiros: state.WhatsappReducer.clearParceiros,
   filtros: state.WhatsappReducer.filtros


})

export default withRouter(connect(mapStateToProps, {
   WhatsappVendedoresListAction,
   WhatsappListAction,
   WhatsappContatoParcListAction,
   WhatsappUpdateContatoParcAction,
   WhatsappInsertContatoParcAction,
   clearParceiros,
   setVendedorFiltro,
   atualizarQuantidadesParceiroLocal
   // WhatsappSalvaPagination
})(Relatorio));


